// transaction
export const documentType={label:"交易类型",name:"documentType"};
export const documentNo={label:"交易号码",name:"documentNum"};
export const supplierTin={label:"供应商TIN",name:"supplierTin"};
export const supplierName={label:"供应商名称",name:"supplierName"};
export const buyerTin={label:"买方TIN",name:"buyerTin"};
export const buyerName={label:"买方名称",name:"buyerName"};
export const startDate={label:"交易日期起",name:"dateFrom"};
export const endDate={label:"止",name:"dateTo"};

export const transactionStatus={label:"交易状态",name:"transactionStatus"};
export const dataIntegrity={label:"数据完整性",name:"dataIntegrity"};
export const invoiceIssued={label:"是否已开具发票",name:"invoiceIssued"};
export const invoiceUuid={label:"电子发票UUID",name:"invoiceUuid"};
export const documentStatus={label:"发票状态",name:"invoiceStatus"};
export const confirmationStatus={label:"发票确认状态",name:"confirmStatusCode"};
export const source={label:"来源",name:"sourceCode"};
export const invoiceStartDate={label:"开票日期起",name:"issuedDateFrom"};
export const invoiceEndDate={label:"止",name:"issuedDateTo"};

export const totalExcludingTax={label:"不含税总额",name:"totalExcludingTax"};
export const totalIncludingTax={label:"含税总额",name:"totalIncludingTax"};
export const totalPayableAmount={label:"应付总额",name:"totalPayableAmount"};
export const totalPayableAmountRange={label:"应付总额范围"};
export const totalTaxAmount={label:"总税额",name:"totalTaxAmount"};
export const currency={label:"货币",name:"currency"};
export const transactionDate={label:"交易日期",name:"transactionDate"};
export const dateTimeIssued={label:"开票时间",name:"dateTimeIssued"};
export const submissionUid={label:"提交UUID",name:"submissionUid"};
export const errorInformation={label:"错误信息",name:"errorInformation"};
export const operationTime={label:"操作时间",name:"operationTime"};
export const uploadTime={label:"上传时间",name:"uploadTime"};

export const invoiceType={label:"电子发票类型",name:"invoiceType"};
export const invoiceCodeNumber={label:"E-Invoice号码",name:"invoiceCodeNumber"};
export const h5InvoiceCodeNumber={label:"收据单号",name:"invoiceCodeNumber"};
export const h5InvoiceCodeNumber2={label:"发票号",name:"invoiceCodeNumber"};
export const oriInvoiceCodeNumber={label:"原发票号",name:"oriInvoiceCodeNumber"};
export const oriInvoiceUuid={label:"原发票UUID",name:"oriInvoiceUuid"};
export const invoiceCurrency={label:"发票货币",name:"invoiceCurrency"};
export const exchangeRate={label:"汇率",name:"exchangeRate"};
export const businessSystem={label:"业务系统",name:"businessSystem"};
export const storeCode={label:"店铺编号",name:"storeCode"};
export const invoiceDateTime={label:"电子发票日期",name:"invoiceDateTime"};
export const actualDateTime={label:"实际日期",name:"actualDateTime"};
export const K1={label:"K1",name:"K1"};
export const K2={label:"K2",name:"K2"};
export const incoterms={label:"国际贸易规则",name:"incoterms"};
export const ftaInformation={label:"FTA信息",name:"ftaInformation"};

export const supplierTin1={label:"TIN",name:"supplierTin"};
export const supplierName1={label:"名称",name:"supplierName"};
export const supplierIdType={label:"证件类型",name:"supplierIdType"};
export const supplierIdValue={label:"证件号码",name:"supplierIdValue"};
export const supplierSst={label:"SST注册号",name:"supplierSst"};
export const supplierTtx = {label:"旅游税登记号",name:"supplierTtx"};
export const supplierContactNum={label:"联系电话",name:"supplierContactNum"};
export const supplierEmail={label:"电子邮箱",name:"supplierEmail"};
export const supplierMsicCode={label:"马来西亚标准行业分类（MSIC）代码",name:"supplierMsicCode"};
export const supplierBusinessDes={label:"业务活动描述",name:"supplierBusinessDes"};
export const supplierCountryCode={label:"国家",name:"supplierCountryCode"};
export const supplierStateCode={label:"州",name:"supplierStateCode"};
export const supplierCityName={label:"城市名称",name:"supplierCityName"};
export const supplierAddressLine0={label:"地址0",name:"supplierAddressLine0"};
export const supplierAddressLine1={label:"地址1",name:"supplierAddressLine1"};
export const supplierAddressLine2={label:"地址2",name:"supplierAddressLine2"};
export const supplierPostalZone={label:"邮政区",name:"supplierPostalZone"};
export const authorisationNumberforCertifiedExporter={label:"认证出口商的许可证编号",name:"authorisationNumberforCertifiedExporter"};
export const customerServiceEmail={label:"客服电子邮箱",name:"customerServiceEmail"};

export const operationDateFrom={label:"操作日期起",name:"operationDateFrom"};
export const operationDateTo={label:"止",name:"operationDateTo"};
export const operator={label:"操作人", name: "operator"};
export const enableBusinessSystem={label:"是否启用业务系统权限",name:"Business System"};


export const buyerTin1={label:"TIN",name:"buyerTin"};
export const h5BuyerTin={label:"税务识别号（TIN）",name:"buyerTin"};
export const buyerName1={label:"名称",name:"buyerName"};
export const buyerIdType={label:"证件类型",name:"buyerIdType"};
export const buyerIdValue={label:"证件号码",name:"buyerIdValue"};
export const buyerSst={label:"SST注册号",name:"buyerSst"};
export const buyerContactNum={label:"联系电话",name:"buyerContactNum"};
export const buyerEmail={label:"电子邮箱",name:"buyerEmail"};
export const buyerMsicCode={label:"马来西亚标准行业分类（MSIC）代码",name:"buyerMsicCode"};
export const buyerCode={label:"买方代码",name:"buyerCode"};
export const buyerCountryCode={label:"国家",name:"buyerCountryCode"};
export const buyerStateCode={label:"州",name:"buyerStateCode"};
export const buyerCityName={label:"城市名称",name:"buyerCityName"};
export const buyerAddressLine0={label:"地址0",name:"buyerAddressLine0"};
export const buyerAddressLine1={label:"地址1",name:"buyerAddressLine1"};
export const buyerAddressLine2={label:"地址2",name:"buyerAddressLine2"};
export const buyerPostalZone={label:"邮政区",name:"buyerPostalZone"};
export const buyerAddressLine={label:"地址",name:"buyerAddressLine0"};

export const classification={label:"分类",name:"classification"};
export const itemName={label:"商品名称",name:"itemName"};
export const itemCode={label:"商品编码",name:"itemCode"};
export const measurement={label:"计量单位",name:"measurement"};
export const quantity={label:"数量",name:"quantity"};
export const unitPrice={label:"单价",name:"unitPrice"};
export const totalBeforeDiscount={label:"折扣前总计",name:"totalBeforeDiscount"};
export const taxAmount={label:"税额",name:"taxAmount"};
export const subtotal={label:"小计",name:"subtotal"};
export const discountRate={label:"折扣率",name:"discountRate"};
export const discountAmount={label:"折扣金额",name:"discountAmount"};
export const discountReason={label:"折扣原因",name:"discountReason"};
export const feeChargeRate={label:"费用/收费标准",name:"feeChargeRate"};
export const feeChargeAmount={label:"费用/收费金额",name:"feeChargeAmount"};
export const feeChargeReason={label:"费用/收费原因",name:"feeChargeReason"};
export const productTariffCode={label:"产品关税代码",name:"productTariffCode"};
export const countryOfOrigin={label:"原产国",name:"countryOfOrigin"};


export const paymentMode={label:"支付方式",name:"paymentMode"};
export const supplierBankAccountNumber={label:"供应商银行账号",name:"supplierBankAccountNumber"};
export const paymentTerms={label:"支付条款",name:"paymentTerms"};
export const prePaymentAmount={label:"预付款金额",name:"prePaymentAmount"};
export const prePaymentDateTime={label:"预付款时间",name:"prePaymentDateTime"};
export const prePaymentReferenceNumber={label:"预付款流水号",name:"prePaymentReferenceNumber"};
export const billReferenceNumber={label:"票据流水号",name:"billReferenceNumber"};

export const taxType={label:"税种类型",name:"taxType"};
export const taxRate={label:"税率",name:"taxRate"};
export const perUnitAmount={label:"单位金额",name:"perUnitAmount"};
export const netAmount={label:"净额",name:"netAmount"};

export const totalNetAmount={label:"总净额",name:"totalNetAmount"};
export const totalDiscountValue={label:"总折扣值",name:"totalDiscountValue"};
export const totalFeeChargeAmount={label:"总费用/收费金额",name:"totalFeeChargeAmount"};
export const roundingAmount={label:"取整/抹零 总额",name:"roundingAmount"};

export const issuerTin={label:"开具方TIN",name:"belongTin"};
export const productDes={label:"产品或服务描述",name:"productDes"};
export const rejectionReason={label:"拒绝原因",name:"rejectionReason"};
export const cancellationReason={label:"取消原因",name:"cancellationReason"};
export const totalAmount={label:"总金额",name:"totalAmount"};
export const buyerType={label:"买方类型",name:"buyerType"};
export const captcha ={label:"验证码"};

export const submissionDateFrom = {label:"提交日期起"};
export const issueDateFrom = {label:"开票日期起"};
export const totalSales={label:"总销售额"};
export const totalDiscount={label:"总折扣"};
export const total={label:"合计",name:"cancellationReason"};
export const totalOriginalSales={label:"原销售额总额"};
export const totalOriginalDiscount={label:"原折扣总额"};
export const netOriginalAmount={label:"原净额"};
export const totalOriginal={label:"Total Original"};
export const cancelDateTime={label:"取消日期时间"};
export const rejectRequestDate={label:"拒绝发起日期时间"};
export const documentStatusReason={label:"文档状态原因"};
export const createdByUserId={label:"创建人ID"};

export const invoicePeriod={label:"发票日期区间"};
export const invoicePeriodFrom={label:"发票日期区间起"};
export const invoicePeriodTo={label:"发票日期区间止"};
export const consolidatedPeriod={label:"合并日期区间"};
export const billingFrequency={label:"计费频率"};

export const transactionSectionA="A部分：基本信息";
export const transactionSectionB="B部分：供应商信息";
export const transactionSectionC="C部分：买方详细信息";
export const transactionSectionD="D部分：商品行详细信息";
export const transactionSectionE="E部分：支付详情";
export const transactionSectionF="F部分：税额信息";
export const transactionSectionG="G部分：附加费";
export const transactionSectionH="H部分：合计";

export const transactionAddress="地址";
export const modifyIssue ="修改&开具";
export const batchSubmit ="批量提交开票";
export const issue ="开票";
export const invoiceIssuance="发票开具";
export const invoiceDetails="发票详情";
export const orderDetails="订单详情";

export const cancelReasons="取消原因";
export const rejectReasons="拒绝原因";

export const transactionTin={label:"交易TIN", name: "tin"};
export const uploadConfirmTip={label:"您确定要上传吗？"};
export const selectOneTip={label:"请选择要上传的文档。"};

export const uploadTemplate="上传模板";
export const uploadedRecords="上传的记录";
export const templateUploadDetails={label:"上传详情", name: "uploadDetails"};
export const templateUploadTime={label:"上传时间", name: "createTime"};
export const templateUploadTimeFrom={label:"上传时间起"};
export const templateUploadTimeTo={label:"止"};
export const templateOperator={label:"操作人", name: "createUserName"};
export const referenceNo={label:"流水号", name: "referenceNo"};
export const fileName={label:"文件名", name: "fileName"};
export const uploadStatus={label:"上传状态", name: "uploadStatus"};
export const totalQuantity={label:"总数量", name: "totalQuantity"};
export const templateSource={label:"来源", name: "source"};
export const incompletedFields={label:"不完整字段", name: "incompletedFields"};
export const shareInvoicePdfTip="您确定要发送吗？";

export const cannotCancelAgain="已取消状态的发票不能再次取消。请检查所选数据。";
export const cannotCancelExpired="72小时后无法取消。请检查所选数据。";
export const rejectCancelledFail="处于已取消状态的发票不能被拒绝。请检查所选数据。";
export const rejectWaitingFail="只有处于等待状态的发票才能被选择拒绝。请检查所选数据。";
export const rejectedRepeat="发票已被拒绝。";
export const rejectWaitingHours="72小时后无法进行拒绝。请检查所选数据。";
export const cannotCancelOtherStatus="只能取消有效发票，请检查所选数据。";

export const voidContent="您确定要作废数据吗？";
export const voidDis="此交易已作废。";
export const voidIssue="此交易已开具电子发票，不能作废。";
export const invalidReasons="无效原因";
export const operationDetails="操作详情";
export const viewInvalidReasons="查看无效原因";
export const viewTransactionInvalidReasonsTip="请选择一个验证失败或发票状态无效的交易数据。";
export const viewInvoiceInvalidReasonsTip="请选择状态无效的发票。";
export const notSameBuyerTin="买方TIN与所选TIN不一致，请修改。";
export const notSameSupplierTin="供应商TIN与所选TIN不一致，请修改。";
export const pdfViewOrShareTip="请选择状态有效的发票。";
export const uploadSuffixLimit="上传的文件必须采用以下格式：.xlsx, .xls, .csv.";
export const uploadFileSizeLimit="最大文件上传限制为10M。";
export const detailsOfTaxExemption="免税详情";
export const invoicingConsolidatedTip="您确定要继续合并开票吗？";
export const consolidatedInvoiceNotAvailableTip="合并发票不可用。";

// invoice
export const invalidReasonStr="TIN和标识类型组合无效";
export const invoicePdfStyle={label:"发票PDF样式",name:"invoicePdfStyle"};

export const uuid={label:"UUID"};
export const longId={label:"标识ID"};
export const internalId={label:"内部ID"};
export const typeName={label:"类型名称"};
export const typeVersionName={label:"类型版本名称"};
export const issuerName={label:"开票人名称"};
export const receiverId={label:"接收人ID"};
export const receiverName={label:"接收人名称"};
export const dateTimeReceived={label:"接收时间"};
export const dateTimeValidated={label:"验证时间"};
export const submissionChannel={label:"提交渠道"};
export const intermediaryName={label:"中介名称"};
export const intermediaryTIN={label:"中介TIN"};
export const searchQuery={label:"搜索查询"};
export const status={label:"状态"};
export const applicableType={label:"适用类型",name:"applicableType"};
//addition Charge
export const additionType={label:"附加类型",name:"additionTypeCode"};
export const additionAmount={label:"额外费用金额",name:"additionAmount"};
export const additionReason={label:"额外费用原因",name:"additionReason"};
export const invalidPaymentModeStr ="请选择一种支付方式。";
export const onlyStoreCode = {label:"店铺编号",name:"storeCode"};
export const billNo = {label:"票据流水号",name:"billNo"};

//consolidate task
export const serialNumber={label:"月任务序列号",name:"serialNumber"};
export const taskDocumentTypeCode={label:"交易类型",name:"taskDocumentTypeCode"};
export const invoicePeriodStr={label:"开票区间",name:"invoicePeriodStr"};
export const taskStartTimeStr={label:"任务开始时间",name:"taskStartTimeStr"};
export const taskEndTimeStr={label:"任务结束时间",name:"taskEndTimeStr"};
export const taskTypeCode={label:"任务类型",name:"taskTypeCode"};
export const failureReasons={label:"失败原因",name:"failureReasons"};


export const validationResult={label:"验证结果",name:"validationResult"};

export const NoPermission="TIN没有此权限。";
export const tinNoPermission="数据所属的TIN没有此权限。";
export const dataHasIssued="此交易已开具电子发票，无法修改。";
export const dataHasVoided="此交易已作废，无法开具发票。";
export const dataHasArchived="存档的数据不能修改、作废或开具发票。";
export const dataStatusError="您选择的数据已开票、作废或不完整。";
export const batchSubmitTransactionPartFail1="条交易数据提交成功，而";
export const batchSubmitTransactionPartFail2="条交易数据提交失败。其中，";
export const batchSubmitTransactionPartFail3="条由于重复提交而导致失败。";
export const batchSubmitTransactionAllFail1="条交易数据提交成功，而";
export const batchSubmitTransactionAllFail2="条交易数据提交失败";
export const batchSubmitTransactionSuccess="所有交易数据均提交成功。";
export const dataHasArchivedAdjustDate="您查询的一些数据已存档。请将日期范围筛选器调整为同月。"
export const issueInvoicesInBulk="您确定要批量开具发票吗？";

export const dataNotEarlierOri="本次提交的发票日期和时间不能早于原始发票，请修改。";
export const generatedTransactionData="在开票之前，将为E-Invoice号码生成交易数据。";
export const invoiceNumberExists="E-Invoice号码已存在。";
export const transactionExistsBringOut="交易已存在，在页面上显示交易数据后，无法修改E-Invoice号码。您确定要显示交易数据吗？";
export const transactionHasInvoiced="E-Invoice号码已开具发票。";
export const totalTaxAmountCanOnlyBeZero="总税额只能为零。";
export const productItemsCannotExceed100Lines="产品项目不能超过100行！";
export const creditNoteCannotExceedOriginalInvoice="Credit Note的总金额不能超过原始发票。";
export const fillProductInfo="请填写产品信息。";
export const fillTaxInfo="请填写税务信息。";
export const totalNetAmountOutOfLimit="数据异常，总净额超限。";
export const totalExcludingTaxOutOfLimit="数据异常，不含税总额超限。";
export const totalTaxAmountOutOfLimit="数据异常，总税额超限。";
export const totalIncludingTaxOutOfLimit="数据异常，含税总额超限。";
export const totalPayableAmountOutOfLimit="数据异常，应付总额超限。";
export const requestAddressIncorrect="请求地址不正确。";
export const submitSuccessCheckEmail="已成功提交。请检查您提供的电子邮件以获取已验证的电子发票。";
export const transactionInfoIncomplete="交易信息不完整，详细信息：\r\n";
export const storeCodeBillExceed="电子发票日期、店铺编号和账单编号不能超过50。";
export const storeCodeBillExceed2="店铺编号与账单编号的组合不能超过50。"
export const invoiceDate={label:"电子发票日期"};
export const invoiceCancelled="条发票数据已成功取消。";
export const insufficienRemainLimit="剩余交易限额不足。";
export const exchangeRateIsRequired="汇率是必需的。";
export const provideProductLine="请提供产品行的税务信息。";
export const provideTaxInfo="请先提供完整的税务信息。";
export const fillBuyerTin="请先填写买方的TIN。";
export const fillSellerTin="请先填写卖方的TIN。";
export const selectTinFirst="请先选择交易TIN。";
export const submitSuccessCheckResultLater="提交成功，请稍后在上传记录中查看上传结果。";
export const downloadTheFiles1="您只能下载";
export const downloadTheFiles2="天内上传的文件。"
export const selectDataFailedUpload="请选择一个上传失败的数据。";
export const fileNotExist="文件不存在，无法下载。";
export const contactDisabled="联系人已被禁用，无法选择。";
export const productDisabled="该产品已被禁用，无法选择。";
export const operatedAccount="操作账号";
export const creditNoteList="Credit Note列表";
export const debitNoteList="Debit Note列表";
export const refundNoteList="Refund Note列表";
export const invoiceQRCodeList="发票二维码列表";
export const invoiceList="发票列表";
export const transactionDataList="交易数据列表";
export const selectDataTip="请选择一个状态为失败或部分成功的数据。";
export const consolidateTaskList="合并任务列表";
export const runConsolidateTask="执行合并任务";
export const viewFailureReasons="查看失败原因";
export const monthTaskSubmitSuccess="提交成功！请稍后查看交易合并任务中的结果。";
export const mergingTaskInProgressTip="当前有正在进行的合并任务，请稍后重试。";
export const dataHasBeenInvoiced="您选择的数据已开具发票。";
export const consolidatedSuccessTip="所有合并交易均已成功提交。";
export const consolidatedFailedTip="所有合并交易均未能提交。";
export const consolidatedPartialSuccessTip1="合并交易已成功提交，而";
export const consolidatedPartialSuccessTip2=" 未能提交。其中，";
export const consolidatedPartialSuccessTip3=" 由于重复提交而未能提交。";
export const consolidatedPartialSuccessTip4="合并交易已成功提交，而";
export const consolidatedPartialSuccessTip5=" 未能提交。";
export const selectTransNotInvoiced="请选择尚未开具发票的交易数据。";
export const transactionIsComplete="该交易数据已完整。";
export const consolidatedTransactionList="合并交易列表";
export const consolidatedInvoiceTip="您确定要继续合并开票吗？";
export const checkIncompletedTip="完整性检查";
export const taxAmountOutOfLimit="数据异常，税额超限。";
export const customsNumFormatTip="只能是字母、数字、逗号。";
export const informationMustBeMaintained="纳税人的基本信息尚未得到维护。";
export const changeTin="此TIN从IRB网站检索。您确定要更改它吗？";
export const unitPriceOutOfLimit="数据异常，数量或单价超限。";
export const quantityOutOfLimit="数据异常，数量乘以单价超限。";
export const fillInTaxTip="请先填写产品的税额信息。";
export const feeChargeAmountOutOfLimit="数据异常，费用/收费金额超出限制。";
export const discountAmountOutOfLimit="数据异常，折扣金额超限。";
export const subtotalOutOfLimit="数据异常，合计超出限制。";
export const reasonTip="原因是：";
export const cancelInvoiceTip1=" 发票已成功取消，而";
export const cancelInvoiceTip2=" 发票未能取消。";
export const additionalDetails="附加详情";
export const purchaseExport="我的进项发票列表";
export const taxDetails="税额信息";
export const transactionDetailsTemplateTip="交易明细只能使用此模板批量导入。";
export const sendEmailTip="发票将发送到此电子邮件地址。";
export const originalNumberOrUUIDisRequired="原始发票代码和原始发票UUID不能都为空。";
export const rangeCheckTip="开始值必须小于结束值";
